import React from 'react'
import './HeaderTitle.css'
import { ChildrenProps } from '../../modules/types'

function HeaderTitle(props: ChildrenProps) {
  return (
    <div id="header-title">
      {props.children}
    </div>
  )
}

export default HeaderTitle
